<div class="aku-holder">
    <aku-header></aku-header>
    <router-outlet>
    </router-outlet>
    <div class="filler"></div>
    <aku-footer></aku-footer>
</div>
